"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateStocksOrBondsData = exports.stocksOrBondsFormRules = exports.stocksOrBondsFieldMapping = exports.stocksOrBondsSchema = void 0;
const converters_1 = require("../../converters");
const asset_1 = require("./asset");
exports.stocksOrBondsSchema = {
    fields: {
        ...asset_1.assetSchema.fields,
    },
    messages: {
        ...asset_1.assetSchema.messages,
    },
};
delete exports.stocksOrBondsSchema.fields.account_number;
delete exports.stocksOrBondsSchema.messages.account_number;
// Field mapping between DTO naming and UI naming
exports.stocksOrBondsFieldMapping = {
    ...asset_1.assetFieldMapping
};
delete exports.stocksOrBondsFieldMapping.account_number;
// 🚀 Pre-computed validations for performance
exports.stocksOrBondsFormRules = (0, converters_1.toReactHookForm)(exports.stocksOrBondsSchema, exports.stocksOrBondsFieldMapping);
exports.validateStocksOrBondsData = (0, converters_1.createValidator)(exports.stocksOrBondsSchema);
